/* Turning API error responses into text a screen can render. */

// The backend's exception handler (modules/common/exceptions.py) wraps DRF's
// body as `{error, detail: <DRF body>, status}`, so a PermissionDenied arrives
// as `detail: {detail: "…"}`. Screens render `data.detail` as text, and an
// object there crashes React. Lift a single message (and its code) up a level.
export const unwrapErrorDetail = (data) => {
  const inner = data?.detail;
  if (!inner || typeof inner !== 'object' || Array.isArray(inner)) return;
  if (typeof inner.detail !== 'string') return;
  if (inner.code && data.code === undefined) data.code = inner.code;
  data.detail = inner.detail;
};

// Always a string, safe to render: a message, a list, or DRF field errors
// ({field: ["msg"]}) joined as "field: msg".
export const apiErrorMessage = (err, fallback = '') => {
  const flat = (v) => {
    if (v == null) return '';
    if (typeof v === 'string') return v;
    if (Array.isArray(v)) return v.map(flat).filter(Boolean).join(' ');
    if (typeof v === 'object') {
      if (typeof v.detail === 'string') return v.detail;
      return Object.entries(v)
        .filter(([k]) => !['error', 'status', 'code'].includes(k))
        .map(([k, x]) => {
          const msg = flat(x);
          return msg && k !== 'detail' && k !== 'non_field_errors' ? `${k}: ${msg}` : msg;
        })
        .filter(Boolean).join(' · ');
    }
    return String(v);
  };
  const data = err?.response?.data;
  return flat(data?.detail ?? data) || fallback;
};
